import { Users, TrendingUp } from "lucide-react";

interface StatsBarProps {
  totalBookings: number;
  unassignedCount: number;
  tablesCount: number;
}

export function StatsBar({
  totalBookings,
  unassignedCount,
  tablesCount,
}: StatsBarProps) {
  return (
    <div className="stats stats-horizontal shadow-sm bg-base-100 border border-base-300">
      <div className="stat py-3 px-4">
        <div className="stat-figure text-primary">
          <Users className="w-6 h-6" />
        </div>
        <div className="stat-title text-xs">Total Bookings</div>
        <div className="stat-value text-2xl">{totalBookings}</div>
      </div>

      <div className="stat py-3 px-4">
        <div className="stat-figure text-accent">
          <Users className="w-6 h-6" />
        </div>
        <div className="stat-title text-xs">Unassigned</div>
        <div className="stat-value text-2xl">{unassignedCount}</div>
      </div>

      <div className="stat py-3 px-4">
        <div className="stat-figure text-success">
          <TrendingUp className="w-6 h-6" />
        </div>
        <div className="stat-title text-xs">Tables</div>
        <div className="stat-value text-2xl">{tablesCount}</div>
      </div>
    </div>
  );
}

